<template>
    <v-container>
        <v-layout>
            <v-flex>
                <v-tooltip top>
                    <v-btn
                            class="mr-2 mb-2"
                            @click="newSale"
                            color="customPurple"
                            dark
                            fixed
                            bottom
                            right
                            fab
                            slot="activator"
                    >
                        <v-icon>add</v-icon>
                    </v-btn>
                    <span>Crear Venta</span>
                </v-tooltip>
                <div>
                    <v-layout>
                        <v-flex xs12 sm6 offset-sm6>
                            <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Buscar"
                                    single-line
                                    hide-details
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>
            <v-dialog
                    v-model="dialog"
                    transition="dialog-bottom-transition"
                    scrollable>
                <v-card tile>
                    <v-toolbar card dark color="nav_background_color">
                        <v-btn icon dark @click.native="dialog = false" @click="cleanData">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Crear nueva venta</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-layout>
                                <v-flex xs12 sm7 offset-sm1>
                                    <v-autocomplete
                                    :items="this.clients"
                                    v-model="sale.cliente"
                                    label="Seleccione un Cliente "
                                    hint="Cliente"
                                    single-line
                                    item-text="completeName"
                                    item-value="id"
                                    return-object
                                ></v-autocomplete>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm7 offset-sm1>
                                    <v-combobox
                                            :items="this.devices"
                                            v-model="sale.dispositivos"
                                            label="Dispositivo"
                                            persistent-hint
                                            multiple
                                            return-object
                                            item-text="name"
                                            item-value="id"
                                    ></v-combobox>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm3 offset-sm1>
                                    <v-text-field
                                            name="valor"
                                            label="Valor"
                                            id="valor"
                                            v-model="sale.valor"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm3 offset-sm1>
                                    <v-text-field
                                            name="iva"
                                            label="IVA"
                                            id="iva"
                                            v-model="sale.iva=(sale.valor*0.12).toFixed(2) "
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm3 offset-sm1>
                                    <v-text-field
                                            name="valorTotal"
                                            label="Valor total"
                                            id="valorTotal"
                                            v-model="sale.valorTotal=(sale.valor*1.12).toFixed(2)"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm3 offset-sm1>
                                    <v-text-field
                                            name="retencion"
                                            label="Retención"
                                            id="retencion"
                                            v-model="sale.retencion"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm3 offset-sm1>
                                    <v-text-field
                                            name="valorTotalRet"
                                            label="Valor total con retención"
                                            id="valorTotalRet"
                                            v-model="sale.valorTotalRetencion=(sale.valorTotal-sale.retencion).toFixed(2)"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-select
                                            :items="this.formasPago"
                                            v-model="sale.formaPago"
                                            label="Forma de Pago"
                                            hint="Forma de pago"
                                            single-line
                                            item-text="name"
                                            item-value="id"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-text-field
                                            v-if="sale.formaPago=='Crédito'"
                                            name="cuotas"
                                            label="Ingrese el número de Cuotas"
                                            id="cuotas"
                                            v-model="sale.cuotas"
                                            required
                                    ></v-text-field>
                                    <v-btn v-if="sale.formaPago=='Crédito'"
                                           @click="calculate" small color="primary">Calcular Cuotas
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                            <v-data-table v-if="sale.formaPago=='Crédito'"
                                          :headers="headersTable"
                                          :items="sale.cuotasLista"
                                          class="elevation-1"
                                          sort-icon="mdi-menu-down"
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <v-text-field v-model="props.item.valorCuota"></v-text-field>
                                    </td>
                                    <td class="text-xs-left">
                                        <v-layout>
                                            <v-flex xs12 sm12 offset-sm1>
                                                <v-menu
                                                        ref="menu2"
                                                        :close-on-content-click="false"
                                                        v-model="props.item.fechaMenu"
                                                        :nudge-right="40"
                                                        :return-value.sync="props.item.fechaTexto"
                                                        lazy
                                                        transition="scale-transition"
                                                        offset-y
                                                        full-width
                                                        min-width="290px">
                                                    <v-text-field
                                                            slot="activator"
                                                            v-model="props.item.fecha"
                                                            label="Fecha de Cuota"
                                                            prepend-icon="event"
                                                            readonly
                                                    ></v-text-field>
                                                    <v-date-picker v-model="props.item.fecha"></v-date-picker>
                                                </v-menu>
                                            </v-flex>
                                        </v-layout>
                                    </td>
                                    <td class="text-xs-left">
                                        <v-layout>
                                            <v-flex xs12 sm12 offset-sm1>
                                                <v-menu
                                                        ref="menu2"
                                                        :close-on-content-click="false"
                                                        v-model="props.item.fechaEfectivaMenu"
                                                        :nudge-right="40"
                                                        :return-value.sync="props.item.fechaEfectivaTexto"
                                                        lazy
                                                        transition="scale-transition"
                                                        offset-y
                                                        full-width
                                                        min-width="290px">
                                                    <v-text-field
                                                            slot="activator"
                                                            v-model="props.item.fechaEfectiva"
                                                            label="Fecha de Efectiva"
                                                            prepend-icon="event"
                                                            readonly
                                                    ></v-text-field>
                                                    <v-date-picker v-model="props.item.fechaEfectiva"></v-date-picker>
                                                </v-menu>
                                            </v-flex>
                                        </v-layout>
                                    </td>
                                    <td class="text-xs-left">
                                        <v-text-field></v-text-field>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                            <v-layout>
                                <v-flex xs12 sm3 offset-sm1>
                                    <v-text-field
                                            name="abono"
                                            label="Abono"
                                            id="abono"
                                            v-model="sale.abono"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm3 offset-sm1>
                                    <v-text-field
                                            name="saldo"
                                            label="Saldo"
                                            id="saldo"
                                            v-model="sale.saldo=(sale.valorTotalRetencion-sale.abono).toFixed(2)"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm9 offset-sm1>
                                    <v-text-field
                                            name="responsable"
                                            label="Responsable"
                                            id="responsable"
                                            v-model="sale.responsable"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm3 offset-sm1>
                                    <v-text-field
                                            name="gananciaInstalador"
                                            label="Ganancia Instalador"
                                            id="gananciaInstalador"
                                            v-model="sale.gananciaInstalador"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm3 offset-sm1>
                                    <v-text-field
                                            name="gananciaResponsable"
                                            label="Ganancia Responsable"
                                            id="gananciaResponsable"
                                            v-model="sale.gananciaResponsable"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm3 offset-sm1>
                                    <v-text-field
                                            name="gananciaPremios"
                                            label="Ganancia Premios"
                                            id="gananciaPremios"
                                            v-model="sale.gananciaPremios"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm6 offset-sm1>
                                    <v-text-field
                                            name="numeroFactura"
                                            label="Número Factura"
                                            id="numeroFactura"
                                            v-model="sale.numeroFactura"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm9 offset-sm1>
                                    <v-textarea
                                            name="observaciones"
                                            label="Observaciones"
                                            id="observaciones"
                                            v-model="sale.observaciones"
                                            required
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm6 offset-sm4>
                                    <div>
                                        <v-btn class="btn-rounded" :disabled="!valid"
                                               @click="saveData" large color="primary">Guardar
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                    <div style="flex: 1 1 auto;"></div>
                </v-card>
            </v-dialog>
        </v-layout>
        <h3 class="primary--text">Lista de Ventas</h3>
        <v-data-table
                :headers="headers"
                :items="sales"
                class="elevation-1"
                sort-icon="mdi-menu-down"
                :search="search"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.fecha }}</td>
                <td class="text-xs-left">{{ props.item.cliente.identification }}</td>
                <td class="text-xs-left">{{ props.item.cliente.firstName}} {{ props.item.cliente.lastName}}</td>
                <td class="text-xs-left">
                    <ul id="example-1">
                        <li v-for="item in props.item.dispositivos">
                            {{ item.name }}
                        </li>
                    </ul>
                </td>
                <td class="text-xs-left">{{ props.item.valorTotal }}</td>
                <td class="text-xs-left">{{ props.item.numeroFactura }}</td>
                <td class="text-xs-left">{{ props.item.formaPago }}</td>
                <td>
                    <v-tooltip top>
                        <v-btn fab small @click="editItem(props.item)" slot="activator" color="white">
                            <img src="../../assets/Editar fondo.png" width="40px"/>
                        </v-btn>
                        <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip top v-if="!isMobile()">
                        <v-btn v-if="$store.getters.isAdmin" fab small @click="deleteItem(props.item)" slot="activator" color="white">
                            <img src="../../assets/Eliminar fondo.png" width="40px"/>
                        </v-btn>
                        <span>Eliminar</span>
                    </v-tooltip>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                No se han encontrado resultados para "{{ search }}".
            </v-alert>
        </v-data-table>
    </v-container>
</template>
<script>
    import Sale from "../../model/Sale";

    export default {
        data() {
            return {
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                headers: [
                    {text: 'Fecha Creación', value: 'fecha'},
                    {text: 'Identificación', value: 'cliente.identification'},
                    {text: 'Nombre', value: 'cliente.lastname'},
                    {text: 'Dispositivos', value: 'dispositivos'},
                    {text: 'Valor Total', value: 'valorTotal'},
                    {text: 'Número Factura', value: 'numeroFactura'},
                    {text: 'Forma Pago', value: 'formaPago'},
                    {text: 'Acciones', value: 'editar'},
                ],
                headersTable: [
                    {text: 'Valor Cuota', value: 'cliente.identification'},
                    {text: 'Fecha Vencimiento', value: 'cliente.lastname'},
                    {text: 'Fecha Efectiva', value: 'dispositivos'},
                    {text: 'Número de comprobante', value: 'valorTotal'},
                ],
                formasPago: ["Crédito", "Corriente", "Efectivo", "Transferencia"],
                editedIndex: -1,
                clients: [],
                devices: [],
                sale: new Sale(),
                sales: [],
                saleObject: {id: "", value: "", date: new Date()},
                menu: false,

            };
        },
        methods: {
            cleanData() {
               // this.$refs.form.reset();
                this.valid = false;
                this.dialog = false;
            },
            newSale() {
                this.editedIndex = -1;
                this.valid = false;
                this.dialog = true;
                this.$refs.form.reset();
                this.sale = new Sale();
            },
            saveData() {
                if (this.$refs.form.validate()) {
                    this.saleObject.value = JSON.stringify(this.sale)
                    this.saleObject.date = new Date()
                    this.saleObject.user = this.sale.cliente
                    this.saleObject.id = this.sale.id
                    this.saleObject.user.clientData = ""
                    if (this.saleObject.id != "") {
                        this.$store.dispatch('updateSale', this.saleObject).then(
                            response => {
                                this.reload();
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                            }
                        );
                    } else {
                        this.$store.dispatch('addSale', this.saleObject).then(
                            response => {
                                this.reload();
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                            }
                        );
                    }
                    this.dialog = false;
                }
            },
            editItem(item) {
                this.editedIndex = this.sales.indexOf(item);
                this.sale = Object.assign({}, item);
                this.dialog = true;
            },
            calculate() {
                this.sale.cuotasLista = []
                for (let i = 0; i < this.sale.cuotas; i++) {
                    this.sale.cuotasLista.push({
                        valorCuota: (this.sale.valorTotalRetencion / this.sale.cuotas).toFixed(2),
                        fecha: "",
                        fechaPago: "",
                        comprobante: "",
                        fechaTexto: "",
                        fechaMenu: "",
                        fechaEfectiva: "",
                        fechaEfectivaTexto: "",
                        fechaEfectivaMenu: "",
                    })
                }
            },
            deleteItem(item) {
                this.editedIndex = this.sales.indexOf(item);
                this.sale = Object.assign({}, item);
                confirm('Está seguro de que quiere eliminar el registro?') &&
                this.$store.dispatch('deleteSale', this.sale.id).then(response => {
                    this.reload()
                })
            },
            changeClient() {
                this.devices = []
                this.sale.dispositivos = []
                this.$store.dispatch('getDevicesByUserLogin', this.sale.cliente.login).then(response => {
                    this.devices = []
                    for (let i = 0; i < response.data.length; i++) {
                        let object = JSON.parse(response.data[i].value)
                        object.id = response.data[i].id
                        this.devices.push(object)
                    }
                })
            },
            reload() {
                this.$store.dispatch('getSales').then(
                    response => {
                        this.sales = []
                        for (let i = 0; i < response.data.length; i++) {
                            let object = JSON.parse(response.data[i].value)
                            object.id = response.data[i].id
                            object.fecha = response.data[i].date
                            this.sales.push(object)
                        }
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                );
                this.$store.dispatch('getClients').then(response => {
                    this.clients = []
                    for (let i = 0; i < response.data.length; i++) {
                      if (response.data[i].clientData != null && response.data[i].clientData != '') {
                        response.data[i].clientData = JSON.parse(response.data[i].clientData)
                      }
                        response.data[i].completeName = response.data[i].firstName + " " + response.data[i].lastName + " - " + response.data[i].login
                        this.clients.push(response.data[i])
                    }

                })
            },
            isMobile() {
              if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
              } else {
                return false
              }
            }
        },
        computed: {},
        created() {
            this.reload()
        }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sale/Sale.vue